/**
 * A small pill that follows the mouse when hovering the menu drawer trigger,
 * matching the "Shop ⌄" cursor hint pattern. Desktop/fine-pointer only —
 * removes itself entirely on touch devices.
 */
class MenuCursorHint extends HTMLElement {
  /** @type {HTMLElement | null} */
  #target = null;

  connectedCallback() {
    this.#target = document.querySelector(this.dataset.target ?? '');
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!this.#target || !supportsHover) {
      this.remove();
      return;
    }

    this.#target.classList.add('header-drawer-cursor-target');
    this.#target.addEventListener('pointerenter', this.#show);
    this.#target.addEventListener('pointerleave', this.#hide);
    this.#target.addEventListener('pointermove', this.#move);
  }

  disconnectedCallback() {
    if (!this.#target) return;
    this.#target.removeEventListener('pointerenter', this.#show);
    this.#target.removeEventListener('pointerleave', this.#hide);
    this.#target.removeEventListener('pointermove', this.#move);
  }

  #show = () => {
    this.classList.add('is-visible');
  };

  #hide = () => {
    this.classList.remove('is-visible');
  };

  /**
   * @param {PointerEvent} event
   */
  #move = (event) => {
    this.style.setProperty('--cursor-x', `${event.clientX}px`);
    this.style.setProperty('--cursor-y', `${event.clientY}px`);
  };
}

if (!customElements.get('menu-cursor-hint')) {
  customElements.define('menu-cursor-hint', MenuCursorHint);
}